//
// ExportDataController.js
// BIRD
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../lib";
import "./ExportVariable";
import "../../models/export/ExportFileFormat";
import "../../models/export/ExportNumberFormat";

var ExportDataController = createModule("BIRD_ExportDataController", [40174], EventDispatcher, [
    {
        EXPORT_WARNING: 50011,
        EXPORT_READY: 50010,
        EXPORT_COMPLETED: 50009,
    },
    ,
    ,
    {
        numberFormat: 4,
        startRow: 4,
        selectedVariables: [1],
        endRow: 4,
        fileFormat: 4,
    },
    {
        getAvailableNumberOfRows: [4],
        isMultipleResultExport: [2],
        prepare: [0],
        getAvailableVariables: [[1]],
        submit: [0],
        reset: [0],
        getExportDetailController: [1],
    },
    ,
    ,
]);
export default ExportDataController;
